import { AfterViewInit, Component, effect, inject, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { HeaderComponent } from './layout/header/header.component';
import { FooterComponent } from './layout/footer/footer.component';
import { LoaderComponent } from "./shared/components/loader/loader.component";
import { BreadcrumbsComponent } from './shared/components/bread-crumbs/bread-crumbs.component';
import { MenuComponent } from './layout/menu/menu.component';
import { filter } from 'rxjs';
import { ToastComponent } from "./shared/components/toast/toast.component";
import { ToastService } from './core/services/toast.service';
import { OAuthService } from 'angular-oauth2-oidc';
import { AuthService } from './core/services/auth.service';
import { NgIf } from '@angular/common';
import { TokenTimerService } from './core/services/token-timer.service';
@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    RouterOutlet,
    HeaderComponent,
    FooterComponent,
    LoaderComponent,
    BreadcrumbsComponent,
    MenuComponent,
    ToastComponent,
    NgIf
],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit, AfterViewInit {
  private readonly route: ActivatedRoute = inject(ActivatedRoute);
  private readonly router: Router = inject(Router);
  private readonly toastSv: ToastService = inject(ToastService);  
  private oauthService: OAuthService = inject(OAuthService);
  private readonly authService: AuthService = inject(AuthService);
  private readonly tokenTimerService: TokenTimerService = inject(TokenTimerService);

  pageSectionName: any;
  @ViewChild('toast') toast!: ToastComponent;

  // if session is active/valid (signal)
  hasActiveSession = this.authService.hasSession();

  constructor() {
    effect(() => {
      console.log('Session expires at', this.tokenTimerService.getMainingTime(), 'minutes');
    });    
  }

  ngOnInit(): void {    
    this.getTitle();
    // console.log(this.authService.isLogedIn);
  }

  ngAfterViewInit(): void {
    this.toastSv.register(this.toast);
  }

  getTitle() {
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(() => {
      const deepestChild = this.getDeepestChild(this.route);
      const title = deepestChild.routeConfig?.title;
      if(title) {
        const [prefixApp, pageSectionName] = (title as string).split(' - ');
        this.pageSectionName = pageSectionName;
      }
    })
  }

  getDeepestChild(route: ActivatedRoute): ActivatedRoute {
    while(route.firstChild) {
      route = route.firstChild;
    }
    return route;
  }
}
